import { _firebase, functions, config } from '@/main.js'

async function video_to_text(video_url) {
  console.log(video_url)
  return functions.httpsCallable('audio-video_to_text', {timeout: 120 * 1000})({video_url: video_url})
}

async function request_identity_verification() {
  return functions.httpsCallable('stripe-request_identity_verification')({})
}

async function text_to_speech(text, voice_id, prefix_text, prefix_url, original_text, original_url, suffix_text, suffix_url, volume, speed, pitch) {
  return functions.httpsCallable('voice-text_to_speech')({text, voice_id, prefix_text, prefix_url, original_text, original_url, suffix_text, suffix_url, volume, speed, pitch})
}

async function descript_setup(voice_id) {
  return functions.httpsCallable('voice-descript_setup')({voice_id})
}

async function create_manage_billing_link(return_url) {
  console.log(return_url)
  return _firebase.app().functions('us-central1').httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink')({returnUrl: return_url})
  // return functions.httpsCallable('ext-firestore-stripe-subscriptions-createPortalLink')({returnUrl: return_url})
}

async function find_invite(email, uid, name) {
  return functions.httpsCallable('team-find_invite')({email, uid, name})
}

async function add_token_to_user(code) {
  return functions.httpsCallable('inbox-add_token_to_user')({code})
}

async function combine_training_data(voice_id) {
  return functions.httpsCallable('voice-combine_training_data_api')({voice_id})
}

async function check_if_voice_is_ready_api(voice_id) {
  return functions.httpsCallable('voice-check_if_voice_is_ready_api')({voice_id})
}

async function signup_and_submit_training_data(voice_id) {
  return functions.httpsCallable('voice-signup_and_submit_training_data')({voice_id})
}

async function audio_to_text(audio_url) {
  return functions.httpsCallable('audio-audio_to_text')({audio_url})
}

async function generate_login_link(email) {
  return functions.httpsCallable('team-generate_login_link')({email})
}

async function render_image_api(image_template_id, image_id) {
  return functions.httpsCallable('image-render_image_api')({image_template_id, image_id})
}

async function record_website(url, force, seconds) {
  force = force || false
  seconds = seconds || 10
  const resp = await fetch(`https://${config.firebase_config.domain}/api/v1/record_website?api_key=ChyLRJg3Qj4w6lW2tOJKChyLRJg3Qj4w6lW2tOJK&force=${force}&seconds=${seconds}&url=${url}`, {method: 'GET'})
  return await resp.json()
}


export default {
  render_image_api, generate_login_link, record_website, audio_to_text, signup_and_submit_training_data, request_identity_verification, check_if_voice_is_ready_api, create_manage_billing_link, video_to_text, text_to_speech, descript_setup, find_invite, add_token_to_user, combine_training_data
}
